<template>
  <el-dialog
    title="主要人员详情"
    :visible.sync="dialogVisible"
    width="1200px"
  >
    <div
      v-loading="!loaded">
      <table class="table ">
        <tr>
          <td class="table-left" width="23%">海关注册编码</td>
          <td width="27%">{{ data.crCode }}</td>
          <td class="table-left" width="23%">注册海关</td>
          <td width="27%">{{ data.customsRegisteredAddress }}</td>
        </tr>
        <tr>
          <td class="table-left">行政区划</td>
          <td>{{ data.administrativeDivision }}</td>
          <td class="table-left">经济区划</td>
          <td>{{ data.economicDivision }}</td>
        </tr>
        <tr>
          <td class="table-left">经营类别</td>
          <td>{{ data.managementCategory }}</td>
          <td class="table-left">行业种类</td>
          <td>{{ data.industryCategory }}</td>
        </tr>
        <tr>
          <td class="table-left">海关注销标志</td>
          <td>{{ data.status }}</td>
          <td class="table-left">年报情况</td>
          <td>{{ data.annualReport }}</td>
        </tr>
        <tr>
          <td class="table-left">注册日期</td>
          <td>{{ data.recordDate }}</td>
          <td class="table-left">报关有效期</td>
          <td width="35%">{{ data.validityDate }}</td>
        </tr>
        <tr>
          <td class="table-left">特殊贸易区域</td>
          <td colspan="3">{{ data.specialTradeArea }}</td>
        </tr>
        <tr>
          <td class="table-left">跨境贸易电子商务类型</td>
          <td colspan="3">{{ data.types }}</td>
        </tr>
      </table>
    </div>

  </el-dialog>
</template>

<script>
import BigPowerTable from "big-power-table"
import {getCompanyRiskInfo} from "@/api/threeYears";

export default {
  name: "ImportsAndExportsDialog",
  data() {
    return {
      dialogVisible: false,
      data: {},
      loaded: false,
    };
  },
  methods: {
    async open(data) {
      this.data = data.detailedTable
      this.loaded = false
      this.dialogVisible = true;
      this.loaded = true
    },

  }
}
</script>

<style lang="stylus" scoped>
>>> .el-dialog__header
  padding 24px 20px 16px
  border-bottom 0 none;

>>> .el-dialog__body
  padding 0px 20px 20px 20px

.table {
  border-collapse: collapse;
  box-shadow: 0px -1px 0px 0px #EEEEEE;
  background #fff;
  width 100%
  border-right 1px solid #EEEEEE;

  td, th {
    padding 10px
    text-align left
    border-right 1px solid #D9D9D9;
    border-bottom 1px solid #EEEEEE;
    border-left 1px solid #EEEEEE;
    font-size: 14px;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.6);
    line-height: 20px;
  }

  td:last-child, th:last-child {
    border-right none;
  }

  thead {
    background: #F0F5FF;
  }

  th {
    color: rgba(0, 0, 0, 0.8);
    font-weight bold
  }


}

.table td:nth-child(odd) {
  background-color: #f0f7fc;
}
</style>
